import omit from 'lodash/omit';
import uniq from 'lodash/uniq';

import './index.scss';

class FormDataSummary {
  constructor(formElement, targetSelector, options) {
    this.inputSelector = 'input:not([data-no-summary]), select:not([data-no-summary]), textarea:not([data-no-summary])';
    this.$form = $(formElement);
    this.$target = this.$form.find(targetSelector);
    this.placeholder = this.$target.data('placeholder');
    this.summary = {};
    this.options = {
      readonly: false,
      ...options
    };

    this._prepare();

    // First Load
    this.refresh();

    // Handle changes
    this.$form.on('change input', this.inputSelector, e => this.change(e.currentTarget));
    $('.q-select-input', this.$form).qselect('on', 'fetch', () => setTimeout(() => this.refresh(), 300));

    this.$form[0].formDataSummary = this;
  }

  static _getDisplayText($elem) {
    const text = ($elem.data('summary-display') || $elem.text() || $elem.val()) || '';
    return text.toString().trim();
  }

  _getInputs() {
    this.$inputs = $(this.inputSelector, this.$form);
  }

  _prepare() {
    const placeholderHtml = `<span class="q-placeholder">${this.placeholder}:</span>`;
    this.$target.append(placeholderHtml);
    this.$main = $('<div class="q-main"></div>');
    this.$target.append(this.$main);

    this.$form.addClass('q-form-data-summary');
    this.$target.addClass('q-summary-tags');
  }

  _getDisplay($input) {
    const isSelect = $input.is('select');
    const isCheckbox = $input.is(':checkbox');
    const isRadio = $input.is(':radio');

    if (!isSelect && !isCheckbox && !isRadio) return FormDataSummary._getDisplayText($input);

    if (isSelect) return $input.find(':selected').toArray().map(option => FormDataSummary._getDisplayText($(option)));

    const display = this.$form
      .find(`[name="${$input.attr('name')}"]:checked`)
      .toArray()
      .map(input => FormDataSummary._getDisplayText($(input)));

    return uniq(display);
  }

  _getCheckedInputsByName(name) {
    return $(`[name="${name}"]:checked`, this.$form);
  }

  _bindRemoveEvents() {
    if (!this.options.readonly) {
      this.$target.find('.js-summary-tag-remove')
        .off('click.tag_remove')
        .on('click.tag_remove', e => {
          const name = $(e.currentTarget).data('name');
          this.remove(name);
        });

      this.$target.find('.js-summary-value-remove')
        .off('click.value_remove')
        .on('click.value_remove', e => {
          const $elem = $(e.currentTarget);
          const name = $elem.data('name');
          const value = $elem.data('value');
          this.removeValue(name, value);
        });
    }
  }

  render() {
    const keys = Object.keys(this.summary);

    if (!keys.length) {
      this.$main.html('<span class="q-empty">Os seus filtros aparecerão aqui.</span>');
      EventManager.publish('formDataSummary.changed', {empty: true});
      return;
    }

    this.$main.html('');

    keys.forEach(name => {
      const item = this.summary[name];
      const $tag = this.buildTag(item);

      this.$main.append($tag);
    });

    EventManager.publish('formDataSummary.changed', {empty: false});
    this._bindRemoveEvents();
  }

  buildTag(item) {
    let value = '';

    if (item.isMultiple) {
      value = item.display
        .map((display, i) => `<div class="q-value-item" data-value="${i}">${display} ${this.options.readonly ? '' :
          `<button type="button"
            class="q-btn-remove js-summary-value-remove"
            data-name="${item.name}"
            data-index="${i}"
            data-value="${item.value[i]}">
            <i class="q-icon q-icon-times-circle"></i>
          </button>` }
        </div>`).join('');
    } else {
      value = `<div class="q-single-value-item">${item.display}</div>`;
    }

    return $(`
      <div class="q-summary-tag">
        <div class="q-heading">
          <span class="q-label">${item.label}</span>
          ${this.options.readonly ? '' : `<button type="button" class="q-btn-remove js-summary-tag-remove" data-name="${item.name}"><i class="q-icon q-icon-times-circle"></i></button>`}
        </div>
        <span class="q-value">${value}</span>
      </div>
    `);
  }

  remove(name) {
    const item = this.summary[name];

    if (item.isMultiple) {
      $(item.value).each((i, value) => {
        this.removeValue(item.name, value);
      });
    } else {
      this.removeValue(item.name, item.value);
    }
  }

  removeValue(name, value) {
    const item = this.summary[name];
    const $input = $(`[name="${item.name}"]` + (item.isCheckable ? `[value="${value}"]` : ''));

    if ($input.is(':checkbox') || $input.is(':radio')) {
      $input.prop('checked', false);
    } else {
      $input.val('', true);
    }

    $input.trigger('change');
  }

  removeEmpty($input, render = true) {
    const name = $input.attr('name');
    const value = $input.val();
    const item = this.summary[name];
    const display = this._getDisplay($input);

    if (!item) return;

    if (item.isCheckable && item.isMultiple) {
      const index = item.value.indexOf(value.toString());

      if (index > -1) {
        this.summary[name].value.splice(index, 1);
        this.summary[name].display = display;

        if (!this.summary[name].value.length)
          this.summary = omit(this.summary, name);
      }
    } else {
      this.summary = omit(this.summary, name);
    }

    if (render) this.render();
  }

  change(element, render = true) {
    const $input = $(element);
    const isCheckable = $input.is(':checkbox') || $input.is(':radio');
    const isCheckbox = $input.is(':checkbox');
    const isRadio = $input.is(':radio');
    const name = $input.attr('name');
    const isEmpty = (!$input.val() || $input.val().toString().length <= 0);
    const isMultiple = $input.attr('multiple') !== undefined || $input.is(':checkbox');
    const hasKey = !!this.summary[name];
    const display = this._getDisplay($input);

    if (!hasKey && ((!isCheckable && isEmpty) || (isCheckable && !$input.is(':checked')))) {
      if (render)
        this.render();
      return;
    }

    if (hasKey && $input.is('[type=text], [type=search], textarea') && (!$input.val() || $input.val().trim() === ''))
      return this.removeEmpty($input, render);

    if (hasKey && isCheckbox && !$input.is(':checked')) {
      return this.removeEmpty($input, render);
    }

    if (hasKey && isRadio && !this._getCheckedInputsByName(name).length) {
      return this.removeEmpty($input, render);
    }

    let value = $input.val();
    if (isMultiple && isCheckable) {
      value = this._getCheckedInputsByName(name).toArray().map(x => x.value.toString());
      value = uniq(value);
    }

    this.summary[name] = {
      name: name,
      value: value,
      display: display,
      label: $input.data('summary-label'),
      isCheckable: isCheckable,
      isMultiple: isMultiple,
      isSelect: !!$input.is('select')
    };

    if (render) this.render();
  }

  refresh() {
    const self = this;
    self.summary = {};

    self._getInputs();
    self.$inputs.toArray().forEach(el => self.change(el, false));
    self.render();
  }
}

(function ($) {
  'use strict';

  if (!$.fn.formDataSummary) {
    $.fn.formDataSummary = function (targetSelector, options = null) {
      const formElement = this;
      const instance = new FormDataSummary(formElement, targetSelector, options);

      return instance.$form;
    };
  }
})(jQuery);
